export type Author = {
  name: string;
  avatar: string;
};

export type ArticleCard = {
  category?: string;
  time: string;
  title: string;
  excerpt?: string;
  img: string;
  author?: Author;
};

export type SidebarRow = {
  time: string;
  title: string;
  img: string;
  category?: string;
  author?: Author;
};

export const TOP_BRANDS: { src: string; alt: string; w: number; h: number }[] = [
  { src: "/images/ej-tech/brand-pill-1.png", alt: "信報", w: 44, h: 24 },
  { src: "/images/ej-tech/brand-pill-2.png", alt: "信健康", w: 96, h: 23 },
  { src: "/images/ej-tech/brand-pill-monthly.png", alt: "EJFQ", w: 66, h: 24 },
  { src: "/images/ej-tech/brand-pill-4.png", alt: "好賞玩", w: 26, h: 26 },
  { src: "/images/ej-tech/brand-pill-24.png", alt: "信報財經月刊", w: 88, h: 24 },
  { src: "/images/ej-tech/brand-pill-5.png", alt: "優雅生活", w: 67, h: 27 },
  { src: "/images/ej-tech/brand-pill-27.png", alt: "Ejinsight", w: 69, h: 27 },
  { src: "/images/ej-tech/brand-pill-6.png", alt: "信報品牌", w: 70, h: 27 },
  { src: "/images/ej-tech/brand-pill-26.png", alt: "信報教育", w: 77, h: 24 },
];

export const NAV_ITEMS = [
  { label: "CEO_AI" },
  { label: "科技動態" },
  { label: "人物專訪" },
  { label: "專家分析" },
  { label: "活動盛事" },
  { label: "HK Startups 融資紀錄" },
  { label: "創新生態圈" },
  { label: "商業合作" },
];

/*
  One avatar per writer.

  `AVATAR_TSAM` was reused for 湛家揚博士, 車品覺 AND 黃岳永, so three columnists
  appeared as the same person down the 專家分析 rail and the /category/experts
  listing — QA: "use different avatars for different authors". Every distinct
  byline now has its own file; the repo ships enough of them.
*/
const AVATAR_AUTHOR_1 = "/images/ej-tech/author-avatar-1.png";
const AVATAR_TSAM = "/images/ej-tech/s4-author-tsam.png";
const AVATAR_FONG = "/images/ej-tech/s4-author-fong.png";
const AVATAR_CHE = "/images/ej-tech/category-avatar-tsam.png";
const AVATAR_WONG = "/images/ej-tech/category-avatar-lin.png";
const AVATAR_LAM = "/images/ej-tech/s2-author-avatar-2.png";

// ── Section 1: hero / lead + 3-card row ─────────────────────────
export const HERO_LEAD: ArticleCard = {
  category: "科技動態",
  time: "12分鐘前",
  title: "Gemini涉教唆自殺｜谷歌捱告 AI自認死者「妻子」 曾鼓勵持刀劫車",
  excerpt:
    "美國佛羅里達州男子加瓦拉斯（Jonathan Gavalas）於2025年10月自殺身亡，終年36歲。近日其父親向加州北區聯邦地區法院提起訴訟，控告谷歌（Google）及其母企Alphabet，指旗下人工智能（AI）聊天機械人Gemini促使加瓦拉斯自殘，最終導致自殺。",
  img: "/images/ej-tech/hero-lead.png",
};

export const HERO_CARDS: ArticleCard[] = [
  {
    category: "CEO_AI",
    time: "12分鐘前",
    title: "編程員最愛 Claude｜支持率達46%",
    img: "/images/ej-tech/hero-card-1.png",
  },
  {
    category: "人物專訪",
    time: "24分鐘前",
    title: "HKTISC｜鼓勵本地製造業 申請「升級」資助",
    img: "/images/ej-tech/hero-card-2.png",
  },
  {
    category: "專家分析",
    time: "57分鐘前",
    title: "預算案促全民用AI 應三管齊下",
    img: "/images/ej-tech/hero-card-3.png",
    author: { name: "郝本尼", avatar: AVATAR_AUTHOR_1 },
  },
];

export const POPULAR_LIST: SidebarRow[] = [
  {
    category: "CEO_AI",
    time: "9分鐘前",
    title: "清華3D打印｜僅須0.6秒破紀錄",
    img: "/images/ej-tech/s2-card-1-chromeos.png",
  },
  {
    category: "CEO_AI",
    time: "18分鐘前",
    title: "WiFi DensePose新技術｜憑WiFi訊號捕捉人類動作",
    img: "/images/ej-tech/s2-card-2-polyu.png",
  },
  {
    category: "CEO_AI",
    time: "4分鐘前",
    title: "港企赴韓交流｜港產研藥AI代理等5企 赴韓交流 科技園領軍 下周參加生物製藥峰會",
    img: "/images/ej-tech/s2-card-3-ai-doxx.png",
  },
  {
    category: "CEO_AI",
    time: "25分鐘前",
    title: "AI軍情系統｜民間用AI代理 3日建軍情系統WorldView 整合公開數據 重演中東戰場",
    img: "/images/ej-tech/s2-card-4-claude.png",
  },
];

// ── Section 2: CEO_AI + 科技動態 ─────────────────────────────────
export const CEOAI_HERO: ArticleCard = {
  category: "五次元",
  time: "12分鐘前",
  title: "網絡成觀賞世盃新主場",
  img: "/images/ej-tech/s2-ceoai-hero-worldcup.png",
  author: { name: "林國誠", avatar: AVATAR_LAM },
};

export const CEOAI_LIST: SidebarRow[] = [
  {
    time: "15分鐘前",
    title: "ChromeOS Flex｜谷歌USB助舊電腦重生 僅售23元",
    img: "/images/ej-tech/s2-card-1-chromeos.png",
  },
  {
    time: "28分鐘前",
    title: "本地科研成果｜受海膽啟發 理大研仿生傳感器",
    img: "/images/ej-tech/s2-card-2-polyu.png",
  },
  {
    time: "45分鐘前",
    title: "AI起底｜研究：AI成功起底67%匿名網民",
    img: "/images/ej-tech/s2-card-3-ai-doxx.png",
  },
  {
    time: "58分鐘前",
    title: "編程員最愛 Claude｜支持率達46%",
    img: "/images/ej-tech/s2-card-4-claude.png",
  },
];

export const TECH_HERO: ArticleCard = {
  time: "12分鐘前",
  title: "網絡安全｜日立數據：查漏洞應涵蓋儲存",
  img: "/images/ej-tech/s2-tech-hero-hitachi.png",
};

export const TECH_LIST: SidebarRow[] = [
  {
    time: "15分鐘前",
    title: "AI內容授權協議｜Meta年付3.9億獲新聞集團授權",
    img: "/images/ej-tech/s2-card-5-meta-newscorp.png",
  },
  {
    time: "28分鐘前",
    title: "AI大腦模型｜獼猴腦反應證明小模型價值",
    img: "/images/ej-tech/s2-card-6-macaque-brain.png",
  },
  {
    time: "45分鐘前",
    title: "創投資金分布｜創投上月注1.5萬億 AI佔九成",
    img: "/images/ej-tech/s2-card-3-ai-doxx.png",
  },
  {
    time: "58分鐘前",
    title: "Qwen離職潮｜阿里Qwen主將林俊暘突離職",
    img: "/images/ej-tech/s2-card-8-qwen.png",
  },
];

export const SIDE_TAGS = [
  "創科KOL",
  "FinTech",
  "人工智能",
  "生物科技",
  "電競",
  "創業文章",
  "Startup本周摘要",
];

// ── Section 3: HK Startups 融資紀錄 ──────────────────────────────
export const STARTUPS_CARDS: ArticleCard[] = [
  {
    category: "科技動態",
    time: "12分鐘前",
    title:
      "ApexPay 完成 Pre-A 輪融資｜攜手偉仕佳傑推動企業級穩定幣結算網絡落地",
    img: "/images/ej-tech/s3-card-1-apexpay.png",
  },
  {
    category: "CEO_AI",
    time: "24分鐘前",
    title: "融資消息｜博歌獲富士康旗下斥2.3億入股",
    img: "/images/ej-tech/s3-card-2-bogo-foxconn.png",
  },
  {
    category: "CEO_AI",
    time: "43分鐘前",
    title: "融資消息｜圓幣完成4000萬美元A2輪融資",
    img: "/images/ej-tech/s3-card-3-yuanbi.png",
  },
  {
    category: "CEO_AI",
    time: "43分鐘前",
    title: "融資消息｜Bowtie獲5.46億C輪融資 Sun Life永明領投",
    img: "/images/ej-tech/s3-card-4-bowtie-sunlife.png",
  },
];

// ── Section 4: 人物專訪 + 專家分析 ──────────────────────────────
export const INTERVIEW_HERO: ArticleCard = {
  time: "12分鐘前",
  title:
    "Sorra｜港產平台AI分析美妝 助理性消費 整合網絡評價 IG逾20萬粉絲",
  img: "/images/ej-tech/s4-interview-thumb-3.png",
};

export const INTERVIEW_LIST: SidebarRow[] = [
  {
    time: "15分鐘前",
    title: "新年消費網騙高危 貪折扣洩密中陷阱",
    img: "/images/ej-tech/s4-interview-thumb-1.png",
  },
  {
    time: "28分鐘前",
    title: "法律界AI｜拓新業務領域 本地律師行藉WiseLaw 打入IPO市場",
    img: "/images/ej-tech/s4-interview-thumb-2.png",
  },
  {
    time: "45分鐘前",
    title: "天工開物AI平台｜助企業快速應用 HKPC倡轉型踏出首步 先找出耗時工序",
    img: "/images/ej-tech/s4-interview-thumb-3.png",
  },
  {
    time: "58分鐘前",
    title: "奧雅納採六類AI｜推動工程轉型 預測設施故障風險 加快建築設計方案",
    img: "/images/ej-tech/s4-interview-thumb-4.png",
  },
];

export const EXPERT_HERO: ArticleCard = {
  category: "創科新視野",
  time: "12分鐘前",
  title: "預算案「AI+」五建議",
  img: "/images/ej-tech/s4-expert-hero.png",
  author: { name: "湛家揚博士", avatar: AVATAR_TSAM },
};

export const EXPERT_LIST: SidebarRow[] = [
  {
    category: "全民大數據",
    time: "15分鐘前",
    title: "人類與AI協作「三七」分工",
    img: "/images/ej-tech/s4-expert-thumb-1.png",
    author: { name: "車品覺", avatar: AVATAR_CHE },
  },
  {
    category: "全民大數據",
    time: "28分鐘前",
    title: "龍蝦AI代理進化論",
    img: "/images/ej-tech/s4-expert-thumb-2.png",
    author: { name: "黃岳永", avatar: AVATAR_WONG },
  },
  {
    category: "科網人語",
    time: "45分鐘前",
    title: "「AI+」開啟香港產業新章",
    img: "/images/ej-tech/s4-expert-thumb-3.png",
    author: { name: "方保僑", avatar: AVATAR_FONG },
  },
  {
    category: "智情筆報",
    time: "58分鐘前",
    title: "預算案促全民用AI 應三管齊下",
    img: "/images/ej-tech/s4-expert-thumb-3.png",
    author: { name: "郝本尼", avatar: AVATAR_AUTHOR_1 },
  },
];

// ── Section 5: 創新生態圈 + 活動盛事 ────────────────────────────
export const ECO_CARDS: ArticleCard[] = [
  {
    time: "12分鐘前",
    title: "本地科研成果｜受海膽啟發 理大研仿生傳感器",
    img: "/images/ej-tech/s5-eco-card1-haidan.png",
  },
  {
    time: "24分鐘前",
    title: "本地科研成果｜理大研EyeAgent 2.0助診眼疾",
    img: "/images/ej-tech/s5-eco-card2-eyeagent.png",
  },
  {
    time: "57分鐘前",
    title: "本地科研成果｜城大鋰電材料 海外拓生產線",
    img: "/images/ej-tech/s5-eco-card3-citu-battery.png",
  },
];

export const EVENT_CARDS: ArticleCard[] = [
  {
    time: "12分鐘前",
    title: "MWC｜21初創出席西班牙通訊大會",
    img: "/images/ej-tech/s5-event-card1-mwc.png",
  },
  {
    time: "24分鐘前",
    title: "港企赴韓交流｜港產研藥AI代理等5企 赴韓交流 科技園領軍 下周參加生物製藥峰會",
    img: "/images/ej-tech/s5-event-card2-korea.png",
  },
  {
    time: "57分鐘前",
    title: "生產力局招聘會｜本周六舉行 設逾萬職缺",
    img: "/images/ej-tech/s5-event-card3-jobfair.png",
  },
];

// ── Footer ───────────────────────────────────────────────────────
/**
 * The footer's own link columns.
 *
 * It used to render the MAIN site's `FOOTER_COLUMNS` filtered to four titles —
 * 即時 / 投資 / 財經 / 地產 and so on, none of which is EJ Tech's subject, and
 * every one a plain string with no destination. QA: "update the foot items to
 * related to ej TECH". Each entry now names a real EJ Tech surface and carries
 * its route.
 */
export const EJTECH_FOOTER_COLUMNS: {
  title: string;
  items: { label: string; href: string }[];
}[] = [
  {
    title: "分類",
    items: [
      { label: "CEO_AI", href: "/ej-tech/category/ceo-ai" },
      { label: "科技動態", href: "/ej-tech/category/tech-pulse" },
      { label: "人物專訪", href: "/ej-tech/category/interviews" },
      { label: "專家分析", href: "/ej-tech/category/experts" },
    ],
  },
  {
    title: "創科生態",
    items: [
      { label: "創新生態圈", href: "/ej-tech/category/ecosystem" },
      { label: "活動盛事", href: "/ej-tech/category/events" },
      { label: "HK Startups 融資榜", href: "/ej-tech/financing-record" },
      { label: "搜尋", href: "/ej-tech/search" },
    ],
  },
  {
    title: "熱門主題",
    items: [
      { label: "人工智能", href: "/ej-tech/tag/%E4%BA%BA%E5%B7%A5%E6%99%BA%E8%83%BD" },
      { label: "FinTech", href: "/ej-tech/tag/FinTech" },
      { label: "生物科技", href: "/ej-tech/tag/%E7%94%9F%E7%89%A9%E7%A7%91%E6%8A%80" },
      { label: "創科KOL", href: "/ej-tech/tag/%E5%89%B5%E7%A7%91KOL" },
    ],
  },
  {
    title: "關於",
    items: [
      { label: "關於 EJ Tech", href: "/ej-tech/about" },
      { label: "信報財經新聞", href: "/" },
      { label: "訂閱", href: "/subscription" },
    ],
  },
];

export const FOOTER_COLUMNS: { title: string; items: string[] }[] = [
  {
    title: "新聞",
    items: [
      "即時",
      "投資",
      "財經",
      "分析",
      "國際",
      "港聞",
      "地產",
      "科技",
      "大灣區",
      "商業",
      "信報視頻",
    ],
  },
  {
    title: "專欄",
    items: [
      "最新專欄",
      "專欄作者",
      "財富管理",
      "投資",
      "經濟",
      "時事",
      "個人理財",
    ],
  },
  {
    title: "市場",
    items: [
      "EJFQ",
      "即時報價",
      "即市排名",
      "指數",
      "股票",
      "IPO",
      "輪證",
      "貴金屬",
      "外匯",
      "我的組合",
      "選股器",
    ],
  },
  {
    title: "信報品牌",
    items: [
      "信報財經月刊",
      "信健康",
      "EJ TECH",
      "EJFQ",
      "優雅生活",
      "Ejinsight",
      "信報教育",
      "信報出版",
      "好·賞·玩商店",
    ],
  },
  {
    title: "政策",
    items: ["服務協議", "私隱政策", "免責聲明"],
  },
  {
    title: "更多",
    items: ["廣告查詢", "關於信報", "加入信報", "聯絡信報"],
  },
];

/**
 * The footer's social row.
 *
 * Every icon was an `<a href="#">` — six controls that looked live and went
 * nowhere. Each carries HKEJ's real account now.
 */
export const SOCIAL_ICONS: { src: string; alt: string; href: string }[] = [
  { src: "/images/ej-tech/icon-facebook.svg", alt: "Facebook", href: "https://www.facebook.com/hkej.ejfq" },
  { src: "/images/ej-tech/icon-youtube.svg", alt: "YouTube", href: "https://www.youtube.com/@hkej" },
  { src: "/images/ej-tech/icon-instagram.svg", alt: "Instagram", href: "https://www.instagram.com/hkej_ejfq/" },
  { src: "/images/ej-tech/icon-medium.svg", alt: "Medium", href: "https://medium.com/@hkej" },
  { src: "/images/ej-tech/icon-weibo.svg", alt: "Weibo", href: "https://weibo.com/hkej" },
  { src: "/images/ej-tech/icon-wechat.svg", alt: "WeChat", href: "https://www.hkej.com" },
];
